///include /assets/js/app/p/card-capture.js
class CardCaptureWorldpay extends CardCaptureDriver {
    static get type() {
        return "worldpay"
    }
    get canCapture() {
        const info = CheckoutInfo.inst.info
        return !!(
            info &&
            info.card &&
            info.card.type == CardCaptureWorldpay.type &&
            info.card.captureKey
        )
    }
    /**
     *
     * @param {?string} return_url
     * @param {boolean} [from_vue]
     */
    init(return_url = null, from_vue = true) {
        /** @type {HTMLFormElement} */
        const pf = document.querySelector("#payment-form")
        if(pf && !pf.getAttribute("action")) {
            const action = safeLocalUrl(return_url, null)
            if(action) {
                pf.action = action
            } else {
                throw new Error(`Invalid return URL: ${return_url}`)
            }
        }
        if(!from_vue) {
            /** @type {HTMLButtonElement} */
            //@ts-ignore
            const submit = document.querySelector(
                "#modal-add-card button.btn-primary, #payment-form button.btn-primary"
            )

            submit.addEventListener(
                "click",
                async () => {
                    await this.submitForm()
                },
            )
        }
    }
    /**
     * @param {HTMLFormElement} pf
     */
    async initForm(pf) {
        if(!pf.getAttribute("action")) {
            throw new Error(`No form action, please see errors`)
        }
        const ci = CheckoutInfo.inst
        await ci.preloadSingle("info")
        await Site.require_once("https://cdn.worldpay.com/v1/worldpay.js")
        Worldpay.useTemplateForm({
            clientKey: ci.info.card.captureKey,
            form: pf.id,
            paymentSection: "payment-section",
            display: "inline",
            saveButton: false,
            reusable: true,
            callback(o) {
                if(o && o.paymentMethod.cardType == "AMEX") {
                    ShowNotification.fail(
                        translation.get('pd_worldpay_notification_fail_amex_not_supported')
                    )
                } else if(o && o.token) {
                    const _el = document.createElement("input")
                    _el.value = o.token
                    _el.type = "hidden"
                    _el.name = "token"
                    pf.appendChild(_el)
                    pf.submit()
                }
            }
        })
    }
    async submitForm() {
        await Site.require_once("https://cdn.worldpay.com/v1/worldpay.js")
        await Worldpay.submitTemplateForm()
    }
}
CardCaptureDriver.add(CardCaptureWorldpay)
